<template>
  <div class="sales">
    <div class="container">
      <div class="head">
        <div class="icon"></div>
        <div class="title">{{ shopName }}</div>
      </div>
      <div
        class="content"
        v-for="item in dataList.slice(0, 3)"
        :key="item.barCode"
        v-show="!showMoreProduct && dataList.length >= 3"
      >
        <img :src="item.defaultImageView" alt="" />
        <div class="basicInfo">
          <div class="name">{{ item.productName }}</div>
          <div class="info">
            <div>材质：{{ item.metalName }}</div>
            <div>下单日期：{{ item.orderTime }}</div>
          </div>
        </div>
      </div>
      <div
        class="content"
        v-for="(item, index) in dataList"
        :key="index"
        v-show="showMoreProduct || dataList.length < 3"
      >
        <img :src="item.defaultImageView" alt="" />
        <div class="basicInfo">
          <div class="name">{{ item.productName }}</div>
          <div class="info">
            <div>材质：{{ item.metalName }}</div>
            <div>下单日期：{{ item.orderTime }}</div>
          </div>
        </div>
      </div>
      <div class="loadMore" v-show="dataList.length >= 3 && showLoadMore">
        <div class="line"></div>
        <div @click.stop="loadMoreData()" class="loadIco">
          <van-icon name="arrow-down" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    shopName: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      showMoreProduct: false,
      showLoadMore: true,
      dataLists: [
        {
          barCode: "666141349050",
          defaultImageView:
            "https://goldmatrix-t.oss-cn-shenzhen.aliyuncs.com/jpg/2022-06/1655803597814.jpg",
          metalName: "14pt",
          orderTime: "2022-07-06 19:02:54",
          productName: "maksajka",
        },
        {
          barCode: "666141349050",
          defaultImageView:
            "https://goldmatrix-t.oss-cn-shenzhen.aliyuncs.com/jpg/2022-06/1655803597814.jpg",
          metalName: "14pt",
          orderTime: "2022-07-06 19:02:54",
          productName: "maksajka",
        },
        {
          barCode: "666141349050",
          defaultImageView:
            "https://goldmatrix-t.oss-cn-shenzhen.aliyuncs.com/jpg/2022-06/1655803597814.jpg",
          metalName: "14pt",
          orderTime: "2022-07-06 19:02:54",
          productName: "maksajka",
        },
        {
          barCode: "666141349050",
          defaultImageView:
            "https://goldmatrix-t.oss-cn-shenzhen.aliyuncs.com/jpg/2022-06/1655803597814.jpg",
          metalName: "14pt",
          orderTime: "2022-07-06 19:02:54",
          productName: "maksajka",
        },
      ],
    };
  },

  mounted() {
    console.log(this.dataLists, "dataLists");
  },

  methods: {
    loadMoreData() {
      this.showMoreProduct = true;
      this.showLoadMore = false;
    },
  },
};
</script>

<style lang="less" scoped>
.sales {
  box-sizing: border-box;
  background: #ededed;
}
.container {
  box-sizing: border-box;
  padding: 32px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 1);
  width: 100%;
  min-height: 264px;
  margin: 0 auto;
  .loadIco {
    text-align: center;
    margin-top: 10px;
  }
}
.head {
  height: 48px;
  min-width: 50px;
  line-height: 48px;
  .icon {
    width: 48px;
    height: 48px;
    background: url("../../../assets/shop.webp") no-repeat;
    background-size: 100%;
    background-position: left;
    float: left;
  }
  .title {
    float: left;
    height: 45px;
    line-height: 50px;
    margin-left: 8px;
    color: rgba(51, 51, 51, 1);
    font-size: 32px;
    font-weight: bold;
  }
}

.content {
  margin-top: 24px;
  min-height: 128px;
}
img {
  background-size: 100%;
  width: 128px;
  height: 128px;
  float: left;
}
.content > div > div {
  font-size: 24px;
}
.basicInfo {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 125px;
  float: left;
  margin-left: 8px;
  .name {
    color: rgba(51, 51, 51, 1);
    font-weight: bold;
    font-size: 26px;
    height: 37px;
    line-height: 37px;
    width: 400px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .info {
    div:nth-child(1) {
      color: rgba(153, 153, 153, 1);
      font-size: 20px;
    }
    div:nth-child(2) {
      height: 28px;
      line-height: 28px;
      color: rgba(51, 51, 51, 1);
      font-size: 20px;
    }
  }
}
.line {
  height: 1px;
  background: rgba(226, 228, 234, 1);
  margin-top: 24px;
}
div {
  font-size: 28px;
}
</style>
